// extracted by mini-css-extract-plugin
export default {"transition":"AnimateBetweenElements_transition_tFgKu","opacity-0":"AnimateBetweenElements_opacity-0_A3egp"};